<template>
    <Splide
        v-if="events.length"
        :options="splideOptions">
        <SplideSlide
            v-for="i in events"
            :key="i.id">
            <EventCard class="tw-mx-auto tw-block" :event="i" />
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import EventCard from './EventCard.vue';

    const props = defineProps<{
        events: any[];
    }>();

    const splideOptions = ref({
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '3rem',
        pagination: false,
        arrows: props.events.length > 3,
        autoplay: props.events.length > 3,
        interval: 2000,
        rewind: true,
        breakpoints: {
            1279: {
                perPage: 2,
                gap: '1rem',
                arrows: props.events.length > 2,
                autoplay: props.events.length > 2,
            },
            800: {
                perPage: 1,
                gap: '1rem',
                arrows: props.events.length > 1,
                autoplay: props.events.length > 1,
            },
        },
    });
</script>

<style scoped></style>
